<template>
  <div>
    <!-- 导航栏 -->
    <LandingNav ref="landingNav" />

    <div id="fullpage">
      <!-- 首屏 -->
      <div class="section">
        <LandingHero ref="landingHero" />
      </div>

      <!-- 极致产品 -->
      <div class="section">
        <LandingGames ref="landingGames" />
      </div>

      <!-- 关于极致 -->
      <div class="section">
        <LandingAbout ref="landingAbout" />
      </div>

      <!-- 加入极致 -->
      <div class="section">
        <LandingJoin />
      </div>

      <!-- Footer -->
      <div id="landing-footer" class="section fp-auto-height">
        <LandingFooter />
      </div>
    </div>
  </div>
</template>

<script>
import LandingNav from '~/components/LandingNav/index.vue'
import LandingGames from '~/components/LandingGames/index.vue'
import LandingHero from '~/components/LandingHero/index.vue'
import LandingAbout from '~/components/LandingAbout/index.vue'
import LandingJoin from '~/components/LandingJoin/index.vue'
import LandingFooter from '~/components/LandingFooter/index.vue'

export default {
  name: 'LandingPage',
  layout: 'landing',
  components: {
    LandingNav,
    LandingGames,
    LandingHero,
    LandingAbout,
    LandingJoin,
    LandingFooter,
  },
  data() {
    return {
      fullpageInstance: null,
    }
  },
  mounted() {
    this.initFullpage()
  },
  beforeDestroy() {
    if (this.fullpageInstance) {
      this.fullpageInstance.destroy('all')
    }
  },
  methods: {
    initFullpage() {
      if (process.client && this.$fullpage) {
        this.$nextTick(() => {
          this.fullpageInstance = new this.$fullpage('#fullpage', {
            // GPLv3 是自由软件基金会（FSF）发布的自由软件许可证
            licenseKey: 'gplv3-license',
            // 不将网站的状态记录到浏览器的历史记录
            recordHistory: false,
            // 内容大于它的高度的情况下保持禁用滚动
            scrollOverflow: false,
            // 当滚动到这些元素时，禁用自动滚动
            // normalScrollElements: '#about-section-intro',
            // 添加回调函数来通知导航栏当前屏幕变化
            onLeave: (origin, destination, direction) => {
              if (this.$refs.landingNav) {
                this.$refs.landingNav.updateCurrentSection(
                  destination.index + 1
                )
              }
              if (this.$refs.landingGames) {
                this.$refs.landingGames.updateCurrentSection(
                  destination.index + 1
                )
              }
              if (this.$refs.landingAbout) {
                this.$refs.landingAbout.updateCurrentSection(
                  destination.index + 1
                )
              }
            },
            afterLoad: (origin, destination, direction) => {
              if (this.$refs.landingNav) {
                this.$refs.landingNav.updateCurrentSection(
                  destination.index + 1
                )
              }
              if (this.$refs.landingGames) {
                this.$refs.landingGames.updateCurrentSection(
                  destination.index + 1
                )
              }
              if (this.$refs.landingAbout) {
                this.$refs.landingAbout.updateCurrentSection(
                  destination.index + 1
                )
              }
            },
          })

          // 将 fullpageInstance 暴露给子组件
          if (this.$refs.landingNav) {
            this.$refs.landingNav.setFullpageInstance(this.fullpageInstance)
          }
          if (this.$refs.landingHero) {
            this.$refs.landingHero.setFullpageInstance(this.fullpageInstance)
          }
          if (this.$refs.landingGames) {
            this.$refs.landingGames.setFullpageInstance(this.fullpageInstance)
          }
          if (this.$refs.landingAbout) {
            this.$refs.landingAbout.setFullpageInstance(this.fullpageInstance)
          }
        })
      }
    },
  },
}
</script>

<style lang="less">
/* 隐藏 fullpage 脚标 */
.fp-watermark {
  display: none;
}

/* SSR 首屏即按 fullpage 全屏轮播布局渲染 .section：
   fullpage.js 只在客户端 mounted 时才给 .section 加上 fp-section class，
   而 fullpage.min.css 只对 .fp-section 生效。若不加这里的高度，
   SSR 首帧 .section 高度坍缩为 0（子组件 .hero/.about 等是 height:100%），
   内容缩成一团，等 fullpage 初始化撑到 100vh 时产生明显跳变（FOUC）。
   这里只给 .section 预设 100vh（与 fullpage 初始化后设置的内联高度一致），
   但绝不给 #fullpage 容器加 height/overflow——fullpage 靠容器 auto 高度
   纵向堆叠所有 section，再用 transform 平移切屏，容器一旦被裁成 100vh
   就会把第 2 屏以后的内容永久裁掉，导致切屏白屏。 */
#fullpage .section {
  position: relative;
  box-sizing: border-box;
  height: 100vh;
  display: block;
}

/* Footer 为自适应高度区段 */
#fullpage .section.fp-auto-height {
  height: auto;
}
</style>
